import Component from '../abstracts/Component';

export default class AddToBagBtnComponent extends Component {

  get SELECTORS() {
    return {
      main: '.jsToBagBtn, .jsToBagBtnStiky',
    };
  }

  constructor() {
    super();
    this.sentAnimClass = 'animate';
  }
  animateBtn(){
    let btns = document.querySelectorAll(this.SELECTORS.main);
    for(let btn of btns){
        btn.classList.add(this.sentAnimClass);
        setTimeout( ()=>{
            btn.classList.remove(this.sentAnimClass);
        },2500);
    }
  }
  initListener(){
      this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart,()=>{
          this.animateBtn();
      });
  }
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
      this.initListener();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
